@if (testimonialsResource.value(); as testimonials) {
    <div #swiperContainer class="swiper">
        <div class="swiper-wrapper">
            @for (testimony of testimonials; track testimony.author) {
                <div class="swiper-slide h-full select-none bg-secondary" lazy="true">
                    <div class="p-6 flex flex-col items-center h-full bg-gray-100 overflow-hidden">
                        <img loading="lazy" width="48" height="34" ngSrc="/assets/quote.png" class="w-12 mb-4" alt="quote" />
                        <span class="flex-auto"></span>
                        <blockquote class="text-base text-center text-gray-600" [innerHTML]="testimony.text | html"></blockquote>
                        <span class="flex-auto"></span>
                        <h4 class="mt-4 font-bold text-gray-700">{{ testimony.author }}</h4>
                        <span class="text-base font-light text-center text-gray-700">{{ testimony.position }}</span>
                    </div>
                </div>
            }
        </div>
        <div class="swiper-pagination"></div>
    </div>
}
